import { render } from "./Influencer2.vue?vue&type=template&id=06ededd1&scoped=true"
import script from "./Influencer2.vue?vue&type=script&lang=js"
export * from "./Influencer2.vue?vue&type=script&lang=js"

import "./Influencer2.vue?vue&type=style&index=0&id=06ededd1&lang=scss&scoped=true"
import "./Influencer2.vue?vue&type=style&index=1&id=06ededd1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ededd1"]])

export default __exports__